module.exports = __webpack_public_path__ + "img/carat@2x.9a261e2.webp";